import { render, staticRenderFns } from "./bindwx.vue?vue&type=template&id=319d92fc&scoped=true"
import script from "./bindwx.vue?vue&type=script&lang=js"
export * from "./bindwx.vue?vue&type=script&lang=js"
import style0 from "./bindwx.vue?vue&type=style&index=0&id=319d92fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319d92fc",
  null
  
)

export default component.exports